export default "__VITE_ASSET__2a13fdfc__"